import { createLifecycleTypes } from '@leagueplatform/web-common';

export const EMPLOYER_BENEFICIARIES_REPORT_LIFECYCLE = createLifecycleTypes(
  'hr/employer-reports/EMPLOYER_BENEFICIARIES_REPORT_LIFECYCLE',
);
